import { render, staticRenderFns } from "./FlexLink.vue?vue&type=template&id=ca44ff10&lang=pug&"
import script from "./FlexLink.vue?vue&type=script&lang=js&"
export * from "./FlexLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports